import { render, staticRenderFns } from "./exchangeDetails.vue?vue&type=template&id=94278964&scoped=true"
import script from "./exchangeDetails.vue?vue&type=script&lang=js"
export * from "./exchangeDetails.vue?vue&type=script&lang=js"
import style0 from "./exchangeDetails.vue?vue&type=style&index=0&id=94278964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94278964",
  null
  
)

export default component.exports